import { useContext } from 'react';
import { WarboxConversationContext } from 'src/contexts/warboxConversation';

export const useWarboxConversation = () =>
    useContext(WarboxConversationContext);
